import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import {
  IntermediateNodeWithConditionalProperties,
  IntermediateNodeWithConditionalsAndOutputs
} from '../../presentationToConductorWorkflow.types'

export const applyOutputMapping =
  (definitions: ResolvedNodeDefinitions) =>
  (
    intermediateNodes: IntermediateNodeWithConditionalProperties[]
  ): IntermediateNodeWithConditionalsAndOutputs[] =>
    intermediateNodes.map(node => {
      if (!node.node.type) throw new Error('nodeType is undefined')

      const definition = definitions[node.node.type as NodeType]

      return {
        ...node,
        outputs: definition.outputMapping?.(node.node.id) ?? {},
        branches: node.branches.map(branch =>
          applyOutputMapping(definitions)(branch)
        ),
        groupContinuations: node.groupContinuations
          ? Object.fromEntries(
              Object.entries(node.groupContinuations).map(([k, v]) => [
                k,
                applyOutputMapping(definitions)(v)
              ])
            )
          : undefined
      }
    })
